import React, { useState, useContext, useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormValidationSchema } from "../models/ValidationSchema";
import { useForm, Controller } from "react-hook-form";
import { submitForm } from "../api/apiManagement";
import { FormContext } from "./Form";
import {
  FormControl,
  InputLabel,
  TextField,
  Button,
  Box,
  Select,
  MenuItem,
  FormHelperText,
  Checkbox,
} from "@mui/material";

import useMediaQuery from "@mui/material/useMediaQuery";
import { LoadingButton } from "@mui/lab";
import i18n from "../i18n";

import { countries } from "../data/Data";

const InfomationPage = () => {
  const { setCurrentStep, data, setData, isLoading, setIsLoading } =
    useContext(FormContext);
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    control,
    setError,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      first_name: data.first_name != null ? data.first_name : null,
      last_name: data.last_name != null ? data.last_name : null,
      email: data.email != null ? data.email : null,
      news_letter: data.news_letter == true ? true : false,
      hkid: data.hkid != null ? data.hkid : null,
      mobile_number: data.mobile_number != null ? data.mobile_number : null,
      select:
        data.select != null
          ? { value: data.select.value, label: data.select.label }
          : { value: "852", label: "+852" },
    },
    resolver: yupResolver(FormValidationSchema),
  });

  const matches = useMediaQuery("(max-width:480px)");

  const formatAnswer = (answersArray) => {
    const formattedAnswers = answersArray
      .map((item) => item.value) // Get the 'value' from each object
      .filter((value) => value !== ""); // Filter out empty strings

    // Join the values into a single string, separated by commas
    return `${formattedAnswers.join(",")}`;
  };

  function formatImei(imeiArray) {
    // Map over the imei array to get the 'value' of each object
    const values = imeiArray.map((item) => item.value);

    // Return the values as a comma-separated string
    return `${values.join(",")}`;
  }

  const onSubmitForm = (d) => {
   
    setIsLoading(true);
    const phoneData = d.select.value + d.mobile_number;
    const submitData = {
      firstName: d.first_name,
      lastName: d.last_name,
      email: d.email,
      phone: phoneData,
      newsLetter: d.news_letter ? 1 : 0,
      hkid: d.hkid,
      pandaCount: formatAnswer(data.answer),
      lang: i18n.language,
      imei: formatImei(data.imei),
      imgId: data.imgId,
    };
    submitForm(submitData)
      .then((res) => {
 
        const currentStatus = res.data.status;
        if (currentStatus == 200) {
          setCurrentStep(3);
        }
        setIsLoading(false);
      })
      .catch((err) => {
      
        setIsLoading(false);
      });
  };

  const backAndSaveData = () => {
    setData({
      ...data,
      first_name: getValues("first_name"),
      last_name: getValues("last_name"),
      email: getValues("email"),
      news_letter: getValues("news_letter"),
      hkid: getValues("hkid"),
      mobile_number: getValues("mobile_number"),
      select: {
        value: getValues("select.value"),
        label: "+" + getValues("select.value"),
      },
      imgId: "",
      answer: "",
    });
    setCurrentStep(1);
  };


  return (
    <div>
      <Box
        sx={{
          height: "100%",
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          flexDirection: matches ? "column" : "row",
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: 100,
            marginRight: matches ? "0px" : "10px",
          }}
        >
          <TextField
            error={!!errors.first_name}
            sx={{ width: "100%" }}
            label={t("global:first_name")}
            {...register("first_name")}
          />
          {errors.first_name && (
            <FormHelperText error>
              <Trans i18nKey="global:first_name_error" />
            </FormHelperText>
          )}
        </Box>
        <Box
          sx={{
            width: "100%",
            height: 100,
            marginLeft: matches ? "0px" : "10px",
          }}
        >
          <TextField
            error={!!errors.last_name}
            sx={{ width: "100%" }}
            label={t("global:last_name")}
            {...register("last_name")}
          />
          {errors.last_name && (
            <FormHelperText error>
              <Trans i18nKey="global:last_name_error" />
            </FormHelperText>
          )}
        </Box>
      </Box>
      <Box sx={{ height: 100 }}>
        <TextField
          error={!!errors.email}
          fullWidth
          label={t("global:email")}
          {...register("email")}
        />
        {errors.email && (
          <FormHelperText error>
            <Trans i18nKey="global:email_error" />
          </FormHelperText>
        )}
      </Box>
      <Box sx={{ height: 100 }}>
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <FormControl sx={{ width: 120 }}>
            <InputLabel
              id="country-code-label"
              sx={{ color: !!errors.mobile_number ? "#d32f2f" : "" }}
            >
              <Trans i18nKey="global:country_code" />
            </InputLabel>
            <Controller
              control={control}
              name="select.value"
              render={({ field }) => (
                <Select
                  label={t("global:country_code")}
                  error={!!errors.mobile_number}
                  {...field}
                  labelId="country-code-label"
                  displayEmpty
                  defaultValue={countries[0].value}
                  onChange={(event) => field.onChange(event.target.value)}
                >
                  {countries.map((country) => (
                    <MenuItem key={country.value} value={country.value}>
                      {country.label}
                    </MenuItem>
                  ))}
                </Select>
              )}
            />
          </FormControl>
          <TextField
            fullWidth
            error={!!errors.mobile_number}
            label={t("global:phone_number")}
            {...register("mobile_number", { required: "fieldRequired" })}
          />
        </Box>
        {errors.mobile_number && (
          <FormHelperText error>
            <Trans i18nKey="global:phone_number_error" />
          </FormHelperText>
        )}
      </Box>
      <Box sx={{ height: 100 }}>
        <TextField
          error={!!errors.hkid}
          fullWidth
          label={t("global:hkid")}
          {...register("hkid")}
          inputProps={{ maxLength: 4 }}
          InputLabelProps={{
            style: {
              fontSize: matches && i18n.language == "hk_en" ? "12px" : "",
              // maxWidth: "100%",
              whiteSpace: matches && i18n.language == "hk_en" ? "pre-wrap" : "",
              // overflow: "hidden",
            },
          }}
        />
        {errors.hkid && (
          <FormHelperText error>
            <Trans i18nKey="global:hkid_error" />
          </FormHelperText>
        )}
      </Box>
      <Box sx={{ height: "100%" }}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Checkbox
            {...register("tnc")}
            sx={{ color: !!errors.tnc ? "#d32f2f" : "" }}
          />
          <FormHelperText error={!!errors.tnc}>
            <span dangerouslySetInnerHTML={{ __html: t("global:tnc") }} />
          </FormHelperText>
        </Box>
        {errors.tnc && (
          <FormHelperText error>
            <Trans i18nKey="global:tnc_error" />
          </FormHelperText>
        )}
      </Box>
      <Box sx={{ height: "100%" }}>
        <Box sx={{ display: "flex", alignItems: "flex-start" }}>
          <Checkbox
            {...register("privacy_policy")}
            sx={{
              paddingTop: "0",
              color: !!errors.privacy_policy ? "#d32f2f" : "",
            }}
          />
          <FormHelperText error={!!errors.privacy_policy}>
            <span
              dangerouslySetInnerHTML={{ __html: t("global:privacy_policy") }}
            />
          </FormHelperText>
        </Box>
        {errors.privacy_policy && (
          <FormHelperText error>
            <Trans i18nKey="global:privacy_policy_error" />
          </FormHelperText>
        )}
      </Box>
      <Box sx={{ height: "100%", marginBottom: "20px" }}>
        <Box sx={{ display: "flex", alignItems: "flex-start" }}>
          <Checkbox
            {...register("news_letter")}
            defaultChecked={data.news_letter == true ? true : false}
            sx={{ paddingTop: "0" }}
          />
          <FormHelperText>
            <span
              dangerouslySetInnerHTML={{ __html: t("global:news_letter") }}
            />
          </FormHelperText>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box sx={{ marginRight: "20px" }}>
          <Button onClick={backAndSaveData} variant="outlined">
            <div className="input-text">
              <Trans i18nKey="global:back" />
            </div>
          </Button>
        </Box>
        <Box sx={{ marginRight: "20px" }}>
          <LoadingButton
            onClick={handleSubmit(onSubmitForm)}
            loading={isLoading}
            variant="outlined"
          >
            <div className="input-text">
              <Trans i18nKey="global:register" />
            </div>
          </LoadingButton>
        </Box>
      </Box>
    </div>
  );
};

export default InfomationPage;
